import { StateCreator } from 'zustand';
import { LayerDefinition } from '@packages/database/types';
import { BasemapType } from './types';
import { basemaps } from '@/components/map/components/controls/BasemapControl';
import { APP_LAYER_REGISTRY } from '@/components/map/config/layerRegistry';

export interface LayerSlice {
  layers: LayerDefinition[];
  activeBasemap: BasemapType;
  addLayer: (layer: LayerDefinition) => void;
  updateLayer: (id: string, updates: Partial<LayerDefinition>) => void;
  removeLayer: (id: string) => void;
  toggleLayerVisibility: (id: string) => void;
  getLayerById: (id: string) => LayerDefinition | undefined;
  setActiveBasemap: (basemap: BasemapType) => void;
}

export const createLayerSlice: StateCreator<LayerSlice> = (set, get) => ({
  layers: [...APP_LAYER_REGISTRY], // Initialize default state
  activeBasemap: 'googleRoadmap',
  addLayer: (layer) => set((s) => ({ layers: [...s.layers, layer] })),
  updateLayer: (id, updates) =>
    set((s) => ({
      layers: s.layers.map((l) => (l.id === id ? { ...l, ...updates } : l)),
    })),
  removeLayer: (id) =>
    set((s) => ({ layers: s.layers.filter((l) => l.id !== id) })),
  toggleLayerVisibility: (id) =>
    set((s) => ({
      layers: s.layers.map((l) =>
        l.id === id ? { ...l, isVisible: !l.isVisible } : l,
      ),
    })),

  getLayerById: (id) => get().layers.find((l) => l.id === id),

  setActiveBasemap: (basemap) => set({ activeBasemap: basemap }),
});
